import React from "react";
import "./styles.css";

export const Tag = ({ children }: any) => {
  return <li className="tag">{children}</li>;
};
